import React from "react"
import moment from "moment"
import SummarySection from "./SummarySection"
import DetailsSection from "./DetailsSection"

const DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm A"

const groupLeaveByUser = leaveDetails =>
  leaveDetails.reduce((acc, row) => {
    const name = row.userName ?? "—"
    if (!acc[name]) acc[name] = []
    acc[name].push(row)
    return acc
  }, {})

const ReportTable = ({ summaryRows, totalRow, detailedRows, leaveDetails = [] }) => {
  const hasReport = summaryRows?.length > 0 || (detailedRows?.length > 0)
  const hasLeave = leaveDetails?.length > 0
  const leaveByUser = hasLeave ? groupLeaveByUser(leaveDetails) : {}

  const SummaryView = () => (
    <>
      {summaryRows?.length ? (
        <SummarySection summaryRows={summaryRows} totalRow={totalRow} />
      ) : (
        <p>No Data Available</p>
      )}
    </>
  )

  if (!hasReport && !hasLeave) {
    return <p className="my-5">No Data Available</p>
  }

  return (
    <React.Fragment>
      <div className="my-5">
        {SummaryView()}
      </div>
      <div>
        {(detailedRows || []).map(group => (
          <DetailsSection rows={group} key={group.name} />
        ))}
      </div>
      {hasLeave && (
        <div className="my-5">
          <h4 className="mb-3">Leave details</h4>
          {Object.entries(leaveByUser).map(([userName, rows]) => (
            <div key={userName} className="my-5">
              <h5 className="mb-3 font-weight-bold text-uppercase" style={{ color: "#1a365d" }}>
                {userName}
              </h5>
              <div className="table-responsive">
                <table className="table table-listing table-hover table-striped">
                  <thead>
                    <tr>
                      <th>On Leave</th>
                      <th>Leave Type</th>
                      <th>Start</th>
                      <th>End</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, idx) => (
                      <tr key={idx}>
                        <td>On Leave</td>
                        <td>{row.leaveType ? String(row.leaveType).replace(/\b\w/g, c => c.toUpperCase()) : "—"}</td>
                        <td>{row.startAt ? moment(row.startAt).format(DATE_TIME_FORMAT) : "—"}</td>
                        <td>{row.endAt ? moment(row.endAt).format(DATE_TIME_FORMAT) : "—"}</td>
                      </tr>
                    ))}
                    <tr className="font-weight-bold bg-secondary text-white">
                      <td colSpan={3}>Total leaves taken</td>
                      <td>{rows.length}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
          <p className="mb-0 font-weight-bold">
            Total leaves taken: {leaveDetails.length}
          </p>
        </div>
      )}
    </React.Fragment>
  )
}

export default ReportTable;
